export const REPORTING_MANAGER_PRIVILEGE = 'REPORTING_MANAGER_PRIVILEGE';
export const REPORTING_ENTITLEMENT = 'REPORTING_ENTITLEMENT';
export const REPORTING_ADMIN_CLAIM = 'REPORTING_ADMIN_CLAIM';
export const REPORTING_DASHBOARD_READ_ALL = 'REPORTING_DASHBOARD_READ_ALL';